import React, { useState } from 'react';
import './CategoryDetailView.css';

export const CATEGORY_DATA = {
  wedding: {
    title: 'Wedding Photography',
    images: [
      '/images/Website%20Photos/wedding_cover.jpg',
      '/images/Website%20Photos/14bddc301f93aee5b77cc8ba1c413ccf.jpg',
      '/images/Website%20Photos/2eb3cf6859dda8b0f434ef3fc1d8dfa4.jpg',
      '/images/Website%20Photos/33b2ff9463238233e4ab96534fcb3cd1.jpg',
      '/images/Website%20Photos/37e713557a5f8e45758d8bb5c0669dbe.jpg',
      '/images/Website%20Photos/7a542bbce7ce133ca7ff2a8bd6aa8dd5.jpg',
      '/images/Website%20Photos/7a81a72096b57c3287ce3239f85075f7.jpg',
      '/images/Website%20Photos/80d76ae6092c53709e85d41fab036b7f.jpg',
      '/images/Website%20Photos/81b71b91630b1418b013da037917d553.jpg',
      '/images/Website%20Photos/83b7960b4e2728a6e59fcdd717f0096d.jpg',
      '/images/Website%20Photos/87022bba0fb097576ff7aa6526781287.jpg',
      '/images/Website%20Photos/90238a71cd31eaee9045786698375634.jpg',
      '/images/Website%20Photos/a11ea96a723fc0bdd9c9ec57df74a818.jpg',
      '/images/Website%20Photos/a79288a00d23472059b1b3f44664ee7d.jpg',
      '/images/Website%20Photos/a9aaa457b9b9d9a360e748c3232b8847.jpg',
      '/images/Website%20Photos/aa17268ef755cdedc61b2d43cd1b1a70.jpg',
      '/images/Website%20Photos/aea495741e017620c661f6d51203dc90.jpg',
      '/images/Website%20Photos/b9707feac7afeb7b493bdd8df9af824c.jpg',
      '/images/Website%20Photos/c6eaa1c39b960cdb1cb071b12261cd3e.jpg',
      '/images/Website%20Photos/d073da440ed6c51555011866f00e23bd.jpg',
      '/images/Website%20Photos/d9419eb51c46a1af21f7d603ebc99532.jpg',
      '/images/Website%20Photos/d97b1c89e6adcc441e874ef73d477f0b.jpg',
      '/images/Website%20Photos/db22aa918ef1ce9c69d0734a45e71812.jpg',
      '/images/Website%20Photos/f0beaca1ac9192b4cd3be1dac9d06aa2.jpg',
      '/images/Website%20Photos/f51f0b6160b5f14bfb0992f81b92b3af.jpg',
      '/images/Website%20Photos/f7d88d6df813aa55a0b27ff16a399d21.jpg',
      '/images/Website%20Photos/fa677fb036bc9c22b696224c3fb0ea40.jpg',
      '/images/Website%20Photos/pexels-909646465-19887758%202.jpg',
      '/images/Website%20Photos/pexels-909646465-19887758.jpg',
      '/images/Website%20Photos/pexels-909646465-20069996.jpg',
      '/images/Website%20Photos/pexels-fotographiya-wedding-photography-823737813-29470592.jpg',
      '/images/Website%20Photos/pexels-picturebyo-8565495.jpg',
      '/images/Website%20Photos/pexels-sampark-films-samparkfilms-com-1300296201-32483856.jpg',
      '/images/Website%20Photos/Nikhil_0118.jpg',
      '/images/Website%20Photos/Nikhil_0135.jpg',
      '/images/Website%20Photos/Nikhil_0214.jpg',
      '/images/Website%20Photos/Nikhil_0317.jpg',
      '/images/Website%20Photos/Nikhil_0329.jpg',
      '/images/Website%20Photos/Nikhil_0349.jpg',
      '/images/Website%20Photos/Nikhil_0367.jpg',
      '/images/Website%20Photos/Nikhil_0387.jpg',
      '/images/Website%20Photos/Nikhil_0396.jpg',
      '/images/Website%20Photos/Nikhil_0406.jpg',
      '/images/Website%20Photos/Nikhil_0503.jpg',
      '/images/Website%20Photos/Nikhil_0522.jpg',
      '/images/Website%20Photos/Nikhil_0529.jpg',
    ]
  },
  upanayan: {
    title: 'Upanayan Photography',
    images: [
      '/images/Upanayan/RAW%20Photo/upanayan_cover.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01215.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01219.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01235.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01269.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01272.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01280.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01281.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01285.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01292.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01293.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01295.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01296.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01305.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01311.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01321.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01327.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01328.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01336.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01339.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01348.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01363.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01365.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01475.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01476.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01493.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01498.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01501.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01502.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01503.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01512.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01513.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01515.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01516.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01530.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01532.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01534.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01535.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01536.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01755.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01761.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01768.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01777.jpg',
      '/images/Upanayan/RAW%20Photo/Nikhil_01779.jpg',
    ]
  },
  birthday: {
    title: 'Birthday Photography',
    images: [
      '/images/Birthday%20Sample/birthday_cover.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5433.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5445.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5446.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5477.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5484.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5488.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5491.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5517.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5529.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5550.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5572.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5600.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5638.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5675.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5682.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5716.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5742.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5747.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5760.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5766.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5806.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5813.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5856.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5860.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5904.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5909.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5910.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5917.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5918.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5923.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5947.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5952.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5978.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_5990.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_6005.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_6010.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_6034.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_6043.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_6055.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_6059.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_6092.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_6123.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_6129.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_6160.jpg',
      '/images/Birthday%20Sample/Bday/Nikhil_6166.jpg',
    ]
  },
  product: {
    title: 'Product Photography',
    images: [
      '/images/Website%20first%20page%20Business/Product.jpg',
      '/images/Website%20first%20page%20Business/_NIK2900.jpg',
      '/images/Website%20first%20page%20Business/_NIK2891%20copy%20copy.jpg',
      '/images/Website%20first%20page%20Business/_NIK2893.jpg',
      '/images/Website%20first%20page%20Business/_NIK2895.jpg',
      '/images/Website%20first%20page%20Business/_NIK2897.jpg',
      '/images/Website%20first%20page%20Business/_NIK2899.jpg',
      '/images/Website%20first%20page%20Business/_NIK2904.jpg',
      '/images/Website%20first%20page%20Business/DSC_0460.JPG',
      '/images/Website%20first%20page%20Business/DSC_0469.JPG',
      '/images/Website%20first%20page%20Business/DSC_0470.JPG',
      '/images/Website%20first%20page%20Business/IMG_2400.JPG',
      '/images/Website%20first%20page%20Business/IMG_3249.JPG',
      '/images/Website%20first%20page%20Business/IMG_3250.JPG',
      '/images/Website%20first%20page%20Business/Nikhil_2859.jpg',
      '/images/Website%20first%20page%20Business/Nikhil_2880.jpg',
      '/images/Website%20first%20page%20Business/Nikhil_3019.jpg',
      '/images/Website%20first%20page%20Business/Nikhil_3097.jpg',
    ]
  },
  food: {
    title: 'Food Photography',
    images: [
      '/images/Food%20Photography/food_cover.jpg',
      '/images/Food%20Photography/_MG_0079.JPG',
      '/images/Food%20Photography/_MG_0087%20copy.jpg',
      '/images/Food%20Photography/_MG_0090%20copy.jpg',
      '/images/Food%20Photography/_MG_0091%20copy%201.jpg',
      '/images/Food%20Photography/_MG_0091%20copy.jpg',
      '/images/Food%20Photography/_MG_0093%20copy.jpg',
      '/images/Food%20Photography/_MG_0121%20copy.jpg',
      '/images/Food%20Photography/_MG_0137%20copy%201.jpg',
      '/images/Food%20Photography/_MG_0137%20copy.jpg',
      '/images/Food%20Photography/_MG_0139%20copy.jpg',
    ]
  },
  couple: {
    title: 'Maternity Photography',
    images: [
      '/images/Dohale%20Jevan/Babyshower/maternity_cover.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6224.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6238.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6242.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6244.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6250.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6255.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6261.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6267.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6268.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6270.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6274.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6278.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6291.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6293.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6295.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6298.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6300.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6321.jpg',
      '/images/Dohale%20Jevan/Babyshower/IMG_6331.jpg',
    ]
  },
  kids: {
    title: 'Kids & Family Photography',
    images: [
      '/images/1/baby_cover.jpg',
      '/images/1/3.jpg',
      '/images/1/31.jpg',
      '/images/1/34.jpg',
      '/images/1/4.jpg',
      '/images/1/asd.jpg',
      '/images/1/DSC_2268.jpg',
      '/images/1/IMG_1919.jpg',
      '/images/1/IMG_1923.jpg',
      '/images/1/IMG_1942.jpg',
      '/images/1/IMG_2098.jpg',
      '/images/1/Nikhil_1381.jpg',
      '/images/1/Nikhil_1402.jpg',
      '/images/1/Nikhil_1407.jpg',
      '/images/1/Nikhil_1421.jpg',
      '/images/1/Nikhil_1431.jpg',
      '/images/1/Nikhil_1446.jpg',
      '/images/1/Nikhil_1469.jpg',
      '/images/1/Nikhil_1484.jpg',
    ]
  },
  fashion: {
    title: 'Fashion Photography',
    images: [
      '/images/Fashion/6x8.jpg',
    ]
  },
  interior: {
    title: 'Interior Photography',
    images: [
      '/images/Interior%20Video/DSC03318%20copy.jpg',
      '/images/Interior%20Video/DSC03379%202%20copy.jpg',
      '/images/Interior%20Video/DSC03448.jpg',
      '/images/Interior%20Video/DSC03483%20copy.jpg',
      '/images/Interior%20Video/DSC03543%20copy.jpg',
      '/images/Interior%20Video/DSC03584%20copy%20(2).jpg',
      '/images/Interior%20Video/DSC03641.jpg',
      '/images/Interior%20Video/DSC03653.JPG',
      '/images/Interior%20Video/DSC03696.jpg',
      '/images/Interior%20Video/DSC03699%20copy.jpg',
      '/images/Interior%20Video/DSC03711%20copy.jpg',
      '/images/Interior%20Video/Nikhil_7562.jpg',
      '/images/Interior%20Video/Nikhil_7563.jpg',
      '/images/Interior%20Video/Nikhil_7564.jpg',
      '/images/Interior%20Video/Nikhil_7566.jpg',
      '/images/Interior%20Video/Nikhil_7567.jpg',
      '/images/Interior%20Video/Nikhil_7574.jpg',
      '/images/Interior%20Video/Nikhil_7583.jpg',
      '/images/Interior%20Video/Nikhil_7586%202.jpg',
      '/images/Website%20first%20page%20Business/Nikhil_7564.JPG',
      '/images/Website%20first%20page%20Business/Nikhil_7566.JPG',
      '/images/Website%20first%20page%20Business/Nikhil_7568.JPG',
      '/images/Website%20first%20page%20Business/Nikhil_7573%20HDR%20Merge.JPG',
      '/images/Website%20first%20page%20Business/Nikhil_7574.JPG',
      '/images/Website%20first%20page%20Business/Nikhil_7576.JPG',
    ],
    videos: [
      '/images/Interior%20Video/WhatsApp%20Video%202025-02-17%20at%207.03.42%20PM_1.mp4'
    ]
  },
  engagement: {
    title: 'Engagement Photography',
    images: [
      '/images/Prewedding%20sample/Prewedding%201/NIK_2261.JPG',
      '/images/Prewedding%20sample/Prewedding%201/NIK_2264.JPG',
      '/images/Prewedding%20sample/Prewedding%201/NIK_2329.JPG',
      '/images/Prewedding%20sample/Prewedding%201/NIK_2387.JPG',
      '/images/Prewedding%20sample/Prewedding%201/NIK_2425.JPG',
      '/images/Prewedding%20sample/Prewedding%201/NIK_3442.JPG',
      '/images/Prewedding%20sample/Prewedding%201/NIK_3446.JPG',
      '/images/Prewedding%20sample/Prewedding%201/NIK_3452.JPG',
      '/images/Prewedding%20sample/Prewedding%201/NIK_3497.JPG',
      '/images/Prewedding%20sample/Prewedding%201/NIK_3504.JPG',
    ]
  },
  portrait: {
    title: 'Portrait Photography',
    images: [
      '/images/Fashion/portrait_1.jpg',
      '/images/Fashion/portrait_2.jpg',
      '/images/Fashion/portrait_3.jpg',
      '/images/Fashion/1.jpg',
      '/images/Fashion/GAN_1510 (2).jpg',
      '/images/Fashion/GAN_1510 (3).jpg',
      '/images/Fashion/GAN_1513.jpg',
      '/images/Fashion/GAN_1517 - 2 .jpg',
      '/images/Fashion/IMG_5267.JPG',
      '/images/Fashion/IMG_5276.JPG',
      '/images/Fashion/IMG_5277.JPG',
      '/images/Fashion/IMG_5294.JPG',
      '/images/Fashion/IMG_5296.JPG',
      '/images/Fashion/IMG_5299.JPG',
      '/images/Fashion/IMG_5305.JPG',
      '/images/Fashion/IMG_5318.JPG',
      '/images/Fashion/IMG_5327.JPG',
      '/images/Fashion/IMG_5336.JPG',
      '/images/Fashion/IMG_5338.JPG',
      '/images/Fashion/IMG_5345.JPG',
      '/images/Fashion/IMG_5363.JPG',
      '/images/Fashion/Nikhil_1474 - 2.jpg',
      '/images/Fashion/Nikhil_5010.JPG',
      '/images/Fashion/Nikhil_5036.JPG',
      '/images/Fashion/Nikhil_5059.JPG',
      '/images/Fashion/Nikhil_5104.JPG',
      '/images/Fashion/Nikhil_5188.JPG',
    ]
  },
  industrial: {
    title: 'Industrial Photography',
    images: [
      '/images/Website%20first%20page%20Business/3_Industrial.jpg',
      '/images/Website%20first%20page%20Business/DSC_0001.jpg',
      '/images/Website%20first%20page%20Business/DSC_0053.jpg',
      '/images/Website%20first%20page%20Business/DSC_0077.jpg',
      '/images/Website%20first%20page%20Business/DSC_0163.jpg',
      '/images/Website%20first%20page%20Business/IMG_2317.JPG',
      '/images/Website%20first%20page%20Business/IMG_2329.JPG',
      '/images/Website%20first%20page%20Business/IMG_2332.JPG',
      '/images/Website%20first%20page%20Business/IMG_2370.JPG',
      '/images/Website%20first%20page%20Business/IMG_2373.JPG',
      '/images/Website%20first%20page%20Business/IMG_2399.JPG',
      '/images/Website%20first%20page%20Business/IMG_2445.JPG',
      '/images/Website%20first%20page%20Business/IMG_2464.JPG',
      '/images/Website%20first%20page%20Business/IMG_2488.JPG',
      '/images/Website%20first%20page%20Business/IMG_2506.JPG',
      '/images/Website%20first%20page%20Business/IMG_2549.JPG',
      '/images/Website%20first%20page%20Business/IMG_2565.JPG',
      '/images/Website%20first%20page%20Business/NIK03795.JPG',
      '/images/Website%20first%20page%20Business/NIK03894.JPG',
      '/images/Website%20first%20page%20Business/Nikhil_03803.jpg',
      '/images/Website%20first%20page%20Business/Nikhil_03813.jpg',
      '/images/Website%20first%20page%20Business/Nikhil_03833.jpg',
      '/images/Website%20first%20page%20Business/Nikhil_03847.jpg',
      '/images/Website%20first%20page%20Business/Nikhil_03914.jpg',
      '/images/Website%20first%20page%20Business/Nikhil_8887.JPG',
      '/images/Website%20first%20page%20Business/Nikhil_9352.JPG',
      '/images/Website%20first%20page%20Business/NIK_5101.JPG',
      '/images/Website%20first%20page%20Business/NIK_5113.JPG',
      '/images/Website%20first%20page%20Business/NIK_5119.JPG',
      '/images/Website%20first%20page%20Business/NIK_5141.JPG',
      '/images/Website%20first%20page%20Business/_NIK5436.JPG',
      '/images/Website%20first%20page%20Business/_NIK5457.JPG',
      '/images/Website%20first%20page%20Business/_NIK5477.JPG',
      '/images/Website%20first%20page%20Business/_NIK5536.JPG',
      '/images/Website%20first%20page%20Business/_NIK5539.JPG',
    ]
  },
  exterior: {
    title: 'Exterior Photography',
    images: [
      '/images/Website first page Business/exterior_building.jpg',
    ]
  },
  corporate: {
    title: 'Corporate Photography',
    images: [
      '/images/Website%20first%20page%20Business/_NIK6661_Corporate.jpg',
      '/images/Website%20first%20page%20Business/IMG_5275.JPG',
      '/images/Website%20first%20page%20Business/IMG_5280.JPG',
      '/images/Website%20first%20page%20Business/IMG_5298.JPG',
      '/images/Website%20first%20page%20Business/_NIK3782.JPG',
      '/images/Website%20first%20page%20Business/_NIK3793.JPG',
      '/images/Website%20first%20page%20Business/_NIK3827.JPG',
      '/images/Website%20first%20page%20Business/_NIK3909.JPG',
      '/images/Website%20first%20page%20Business/_NIK3911.JPG',
      '/images/Website%20first%20page%20Business/_NIK4008.JPG',
      '/images/Website%20first%20page%20Business/_NIK4018.JPG',
      '/images/Website%20first%20page%20Business/_NIK6737.JPG',
      '/images/Website%20first%20page%20Business/_NIK9808.JPG',
      '/images/Website%20first%20page%20Business/_NIK9824.JPG',
      '/images/Website%20first%20page%20Business/_NIK9851.JPG',
      '/images/Website%20first%20page%20Business/_NIK9895.JPG',
      '/images/Website%20first%20page%20Business/_NIK9896.JPG',
      '/images/Website%20first%20page%20Business/_NIK9901.JPG',
    ]
  },
  sport: {
    title: 'Sports Photography',
    images: [
      '/images/Website%20first%20page%20Business/IMG_9500_Sports.JPG',
      '/images/Website%20first%20page%20Business/IMG_0205.JPG',
      '/images/Website%20first%20page%20Business/IMG_1376.JPG',
      '/images/Website%20first%20page%20Business/IMG_4048.JPG',
      '/images/Website%20first%20page%20Business/IMG_4051.JPG',
      '/images/Website%20first%20page%20Business/IMG_4060.JPG',
      '/images/Website%20first%20page%20Business/IMG_4068.JPG',
      '/images/Website%20first%20page%20Business/IMG_4103.JPG',
      '/images/Website%20first%20page%20Business/IMG_9506.JPG',
      '/images/Website%20first%20page%20Business/IMG_9508.JPG',
      '/images/Website%20first%20page%20Business/IMG_9509.JPG',
      '/images/Website%20first%20page%20Business/IMG_9587.JPG',
      '/images/Website%20first%20page%20Business/_NIK3068.JPG',
    ]
  },
  wildlife: {
    title: 'Wildlife Photography',
    images: [
      '/images/Website%20first%20page%20Business/NIK_9518_Wildlife.jpg',
      '/images/Website%20first%20page%20Business/NIK_7081.JPG',
      '/images/Website%20first%20page%20Business/NIK_7082.JPG',
      '/images/Website%20first%20page%20Business/NIK_7635%20copy.jpg',
      '/images/Website%20first%20page%20Business/NIK_7784.JPG',
      '/images/Website%20first%20page%20Business/NIK_7788.JPG',
      '/images/Website%20first%20page%20Business/NIK_7851%20copy.jpg',
      '/images/Website%20first%20page%20Business/NIK_7912.JPG',
      '/images/Website%20first%20page%20Business/NIK_8577%20copy.jpg',
      '/images/Website%20first%20page%20Business/NIK_9586.JPG',
      '/images/Website%20first%20page%20Business/NIK_9695.JPG',
      '/images/Website%20first%20page%20Business/NIK_9703.JPG',
      '/images/Website%20first%20page%20Business/NIK_9844.JPG',
      '/images/Website%20first%20page%20Business/NIK_9847.JPG',
      '/images/Website%20first%20page%20Business/_NIK5352%20copy.jpg',
      '/images/Website%20first%20page%20Business/_NIK5359%20copy.jpg',
      '/images/Website%20first%20page%20Business/_NIK9479.JPG',
      '/images/Website%20first%20page%20Business/_NIK9491.JPG',
    ]
  }
};

const CategoryDetailView = ({ category, onBack, onViewMore }) => {
  const data = CATEGORY_DATA[category.id] || {
    title: category.title,
    images: [category.image],
    videos: []
  };

  const displayedImages = data.images.slice(0, 20);
  const displayedVideos = (data.videos || []).slice(0, 5);
  const hasMore = data.images.length > 20;

  return (
    <div className="category-detail">
      <div className="container">
        <button className="back-btn" onClick={onBack}>← Back to Categories</button>
        <h2 className="detail-title">{data.title}</h2>

        {displayedVideos.length > 0 && (
          <div className="video-grid">
            {displayedVideos.map((video, idx) => (
              <div key={`video-${idx}`} className="detail-video-card">
                <video
                  src={video}
                  controls
                  className="category-video"
                  poster={data.images[0]}
                >
                  Your browser does not support the video tag.
                </video>
              </div>
            ))}
          </div>
        )}

        <div className="detail-grid">
          {displayedImages.map((img, idx) => (
            <div key={idx} className="detail-image-card">
              <img src={img} alt={`${data.title} ${idx + 1}`} />
            </div>
          ))}
        </div>

        {hasMore && (
          <div className="view-more-container">
            <button className="view-more-btn" onClick={() => {
              if (onViewMore) {
                const filterName = category.id.charAt(0).toUpperCase() + category.id.slice(1);
                onViewMore(filterName);
              }
            }}>
              View More
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryDetailView;